module.exports = __webpack_public_path__ + "img/nodata.e6056eab.png";